import { mixed, number, object, string } from 'yup';
import { checkIsraeliPhone } from '../helpers';
import { emptyValueCheck } from './customValidations';

export const actionPermissionsListSearchValidation = object().shape({
  InquiringPhoneNumber: string().test(
    'check-inquiring-phone',
    'מספר הטלפון לא תקין',
    (value) => (value ? checkIsraeliPhone(value) : true)
  ),
  AuthorizerPhoneNumber: string().test(
    'check-authorizer-phone',
    'מספר הטלפון לא תקין',
    (value) => (value ? checkIsraeliPhone(value) : true)
  ),
  InquiringCustomerId: number().transform(emptyValueCheck).nullable(),
  AuthorizerCustomerId: number().transform(emptyValueCheck).nullable(),
  CityId: number().transform(emptyValueCheck).nullable(),
  SiteId: number().transform(emptyValueCheck).nullable(),
  CellId: number().transform(emptyValueCheck).nullable(),
  From: mixed().test('check-from-date', 'טווח התאריכים שגוי', function (value) {
    const to = this.parent.To;
    if (!value || !to) return true;
    return new Date(value as string) <= new Date(to)
      ? true
      : this.createError({ message: 'טווח התאריכים שגוי', path: 'From' });
  }),
  To: mixed().test('check-to-date', 'טווח התאריכים שגוי', function (value) {
    const from = this.parent.From;
    if (!value || !from) return true;
    return new Date(value as string) >= new Date(from)
      ? true
      : this.createError({ message: 'טווח התאריכים שגוי', path: 'To' });
  }),
});
